import { Box, TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LocationSearchBox = styled(Box)`
  width: 100%;
`;

export const StyledTableCell = styled(TableCell)`
  border: 0;
`;